export const mobileBreakpoint = '800px';
export const materialSMBreakpoint = '600px';

export default {
  mobileBreakpoint,
  materialSMBreakpoint,
};
